enum DATA_TYPE {
    EVENT = 'event',
    DEMAND = 'demand',
    STRING = 'string',
    OCCUPANCY = 'occupancy',
    COMPONENT = 'component',
}

export default DATA_TYPE;
